import authApi from '../../../services/auth.axios';
import AuthError from '../domain/AuthError';
import OrderNotFoundError from '../domain/OrderNotFoundError';

function isInvalidCredentialsLoginPayload(payload) {
  const errors = Array.isArray(payload?.error?.errors)
    ? payload.error.errors.map((item) => String(item).toLowerCase())
    : [];

  return errors.includes('correo inválido');
}

function mapLoginApiError(payload) {
  if (isInvalidCredentialsLoginPayload(payload)) {
    return new OrderNotFoundError();
  }
  return new AuthError();
}

async function loginWithoutIdk({ email, orderHigherIdExt }) {
  try {
    const { data } = await authApi.post('/login', {
      email,
      orderHigherIdExt,
    });

    return data.data;
  } catch (error) {
    if (error instanceof OrderNotFoundError || error instanceof AuthError) {
      throw error;
    }
    throw mapLoginApiError(error?.response?.data);
  }
}

export default function cerateAuthApiRepository() {
  return {
    loginWithoutIdk,
  };
}
